<div class="modal-header" id="request-notification-modal-title">
    <h3 class="modal-title" id="modal-title" translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_TITLE"></h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="requestNotificationForm">
        <fieldset formArrayName="formChildren" [disabled]="isLoading">
            <div class="form-horizontal">
                @if (!!model.equipmentNo) {
                    <div class="row mb-3">
                        <label
                            class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                            for="equipmentNo"
                            translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_EQUIPMENT_NUMBER"
                        ></label>
                        <div class="col-sm-7 col-12">
                            <pace-core-text-input
                                id="equipmentNo"
                                [(model)]="model.equipmentNo"
                                (valueChange)="validateForm()"
                                [parentForm]="formChildren"
                                [ariaLabel]="'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_EQUIPMENT_NUMBER' | translate"
                            ></pace-core-text-input>
                        </div>
                    </div>
                }
                @if (!!model.technicalIdentNo) {
                    <div class="row mb-3">
                        <label
                            class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                            for="technicalIdentNo"
                            translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_TECH_IDENT_NUMBER"
                        ></label>
                        <div class="col-sm-7 col-12">
                            <pace-core-text-input
                                id="technicalIdentNo"
                                [(model)]="model.technicalIdentNo"
                                (valueChange)="validateForm()"
                                [parentForm]="formChildren"
                                [ariaLabel]="'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_TECH_IDENT_NUMBER' | translate"
                            ></pace-core-text-input>
                        </div>
                    </div>
                }
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                        for="functionalLoc"
                        translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_FUNC_LOCATION_NUMBER"
                    ></label>
                    <div class="col-sm-7 col-12">
                        <pace-core-text-input
                            id="functionalLoc"
                            [(model)]="model.functionalLoc"
                            (valueChange)="validateForm()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_FUNC_LOCATION_NUMBER' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                        for="material"
                        translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_MATERIAL_NUMBER"
                    ></label>
                    <div class="col-sm-7 col-12">
                        <pace-core-text-input
                            id="material"
                            [(model)]="model.material"
                            (valueChange)="validateForm()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_MATERIAL_NUMBER' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                        for="serialNo"
                        translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_SERIAL_NUMBER"
                    ></label>
                    <div class="col-sm-7 col-12">
                        <pace-core-text-input
                            id="serialNo"
                            [(model)]="model.serialNo"
                            (valueChange)="validateForm()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_SERIAL_NUMBER' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                        for="dropdownEffectCode"
                        translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_EFFECT_CODE"
                    ></label>
                    <div class="col-sm-7 col-12">
                        <pace-core-dropdown
                            [(model)]="model.effectCode"
                            id="dropdownEffectCode"
                            [parentForm]="formChildren"
                        ></pace-core-dropdown>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                        for="issueText"
                        translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_ISSUE_REPORTED"
                    ></label>
                    <div class="col-sm-7 col-12">
                        <pace-core-text-input
                            id="issueText"
                            [(model)]="model.issueText"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_ISSUE_REPORTED' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                        translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_SUGGESTED_APPOINTMENT"
                    ></label>
                    <div class="col-sm-7 col-12">
                        <div class="row">
                            <div class="col-sm-7 col-12">
                                <pace-core-date-input
                                    id="date"
                                    [(model)]="model.frontDate"
                                    [parentForm]="formChildren"
                                    [ariaLabel]="
                                        'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_SUGGESTED_APPOINTMENT_DATE' | translate
                                    "
                                ></pace-core-date-input>
                            </div>
                            <div class="col-sm-5 col-12 mt-sm-0 mt-3">
                                <pace-core-time-input
                                    id="time"
                                    [(model)]="model.frontTime"
                                    [parentForm]="formChildren"
                                    [ariaLabel]="
                                        'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_SUGGESTED_APPOINTMENT_TIME' | translate
                                    "
                                ></pace-core-time-input>
                            </div>
                        </div>
                    </div>
                </div>
                @if (showStartImmediately) {
                    <div class="row mb-3">
                        <div class="col-8 offset-sm-4 d-flex align-items-center gap-3">
                            <pace-core-checkbox-input
                                checkBoxID="startImmediatelyRequest"
                                [(model)]="model.startImmediately"
                                (valueChange)="model.onChangeStartImmediately()"
                                [parentForm]="formChildren"
                            ></pace-core-checkbox-input>
                            @if (showRemoteWork) {
                                <pace-core-checkbox-input
                                    checkBoxID="remoteWorkRequest"
                                    [(model)]="model.remoteWork"
                                    [parentForm]="formChildren"
                                    [isReadonlyInputControl]="!model.startImmediately.value"
                                ></pace-core-checkbox-input>
                            }
                        </div>
                    </div>
                }
                @if (!!model.jobDuration) {
                    <div class="row mb-3">
                        <label
                            class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                            for="durationStepper"
                            translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_DURATION"
                        ></label>
                        <div class="col-sm-7 col-12">
                            <pace-core-duration-stepper
                                id="durationStepper"
                                [parentForm]="formChildren"
                                [(model)]="model.jobDuration"
                                [ariaLabel]="'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_DURATION' | translate"
                            >
                            </pace-core-duration-stepper>
                        </div>
                    </div>
                }
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                        for="callerName"
                        translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_CALLER_NAME"
                    ></label>
                    <div class="col-sm-7 col-12">
                        <pace-core-text-input
                            id="callerName"
                            [(model)]="model.callerName"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_CALLER_NAME' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-12 text-start text-sm-end col-form-label"
                        for="callerPhoneNo"
                        translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_CALLER_PHONE"
                    ></label>
                    <div class="col-sm-7 col-12">
                        <pace-core-text-input
                            id="callerPhoneNo"
                            [(model)]="model.callerPhoneNo"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_CALLER_PHONE' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    @if (!isLoading) {
        <button
            class="btn btn-primary"
            type="button"
            (click)="requestNotification()"
            [disabled]="requestNotificationForm.invalid"
            translate="DASHBOARD_SIDEMENU_CREATE_NOTIFICATION_CREATE"
        ></button>
    }
    @if (isLoading) {
        <progressbar type="default" [striped]="true" [value]="100">Sending request...</progressbar>
    }
</div>
